import {useMutation, useQuery, useQueryClient} from 'react-query';
import PageService from '../services/PageService';
import {useCMS} from 'tinacms';

const getFromCache = (client, slug, admin) => {
  const page = client.getQueryData([slug, admin]);
  if (admin && !page)
    return client.getQueryData([slug, !admin]);
  return page;
};

export const useFindPage = (slug, cache, admin) => {
  const client = useQueryClient();
  const {isLoading, error, data, isSuccess} = useQuery([slug, admin], () => {
    if (cache) {
      const page = getFromCache(client, slug, admin);
      if (page)
        return Promise.resolve(page);
    }
    const adminParams = admin ? {admin: true} : {};
    return PageService.getPageBySlug(slug, {
      params: {
        in18: false,
        ...adminParams
      }
    });
  },
  {
    refetchOnWindowFocus: false
  }
  );
  return {
    isSuccess, isLoading, error, data: data || []
  };
};


export const usePageSave = (slug) => {
  const queryClient = useQueryClient();
  const cms = useCMS();

  const {mutate, isLoading} = useMutation(PageService.save, {
    onSuccess: () => {
      queryClient.invalidateQueries(slug).then();
      queryClient.removeQueries(slug);
      cms.alerts.success('Block saved successfully.');
    },
    onError: (e) => {
      cms.alerts.error(`Error saving Block: ${e.message}`);
    }
  });

  return {
    mutate,
    isLoading
  };
};
